export default __webpack_public_path__ + "static/kit-839e259c09ece009d530e96c2a59fc9a.png";